import { Component } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ClientUpdatedService } from 'common/services/client-updated/client-updated.service';

@Component({
  templateUrl: './new-version-snackbar.component.html',
  styleUrls: [ '../alerts-snackbar/alerts-snackbar.component.less', './new-version-snackbar.component.less' ],
})
export class NewVersionSnackbarComponent {
  sbRef!: MatSnackBarRef<NewVersionSnackbarComponent>; // set after component construction

  constructor(private clientUpdatedService: ClientUpdatedService) {}

  dismiss(): void {
    this.sbRef.dismiss();
  }

  refresh(): void {
    this.clientUpdatedService.applyUpdateAndReload();
  }
}
